export default "__VITE_ASSET__7d8aeb02__"